import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { requestAPIActions } from 'loopback-react-request';

export interface ThreeDataDispatcherProps {
  dispatch: Function;
  threeData: GlobalPrivateState['threeData'];
}

const dispatchKey = 'threeData';

// const isLocalStorageNameSupported = () => {
//   var testKey = 'test', storage = window.sessionStorage;
//   try {
//       storage.setItem(testKey, '1');
//       storage.removeItem(testKey);
//       return true;
//   } catch (error) {
//       return false;
//   }
// }

export class ThreeDataDispatcherPartial extends React.Component<ThreeDataDispatcherProps> {
  componentDidMount() {
    const {
      threeData
    } = this.props;

    if (!threeData.result) {
      this.dispatchThreeData();
    }

    // if (this.threeDataFromLocalStorage && !threeData.result) {
    //   this.props.dispatch(requestAPIActions.loadPlain(
    //     dispatchKey,
    //     this.threeDataFromLocalStorage,
    //   ));
    // }
  }

  componentDidUpdate() {
    // const {
    //   threeData
    // } = this.props;

    // if (!this.threeDataFromLocalStorage && threeData.result && isLocalStorageNameSupported()) {
    //   localStorage.setItem(dispatchKey, JSON.stringify(threeData.result));
    // }
  }
  
  public render() {
    return null;
  }

  // private get threeDataFromLocalStorage(): {[key: string]: unknown} | undefined {
  //   if (!isLocalStorageNameSupported()) {
  //     return;
  //   }
  //   const threeData = localStorage.getItem(dispatchKey);
  //   return threeData && JSON.parse(threeData);
  // }

  private dispatchThreeData() {
    this.props.dispatch(requestAPIActions.load(
      dispatchKey, {
        url: `/Parts/3d-models`,
      },
      true
    ));
  }
}

export const ThreeDataDispatcher = connect((state: GlobalPrivateState) => ({
  threeData: state.threeData,
}))(ThreeDataDispatcherPartial);